// Demo email form: validates, sends NOTHING, and shows a popup notification.
// Active only while Customizer > "Landing: Email capture" has no real
// Contact Form 7 shortcode (template-parts/newsletter.php renders the demo
// form in that case).
document.addEventListener("DOMContentLoaded", function () {
  var form = document.querySelector(".js-newsletter-form");
  if (!form) {
    return;
  }

  var input = form.querySelector('input[type="email"]');
  var msg = form.querySelector("[data-newsletter-msg]");
  var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  var toast = null;
  var timer = null;

  function hideToast() {
    if (toast) {
      toast.classList.remove("is-visible");
    }
    clearTimeout(timer);
  }

  function showToast(title, text) {
    if (!toast) {
      toast = document.createElement("div");
      toast.className = "toast";
      toast.setAttribute("role", "status");
      toast.setAttribute("aria-live", "polite");
      toast.innerHTML =
        '<span class="toast__icon" aria-hidden="true">✓</span>' +
        '<div class="toast__body"><p class="toast__title"></p><p class="toast__text"></p></div>' +
        '<button type="button" class="toast__close" aria-label="Close notification">×</button>';
      toast.querySelector(".toast__close").addEventListener("click", hideToast);
      document.body.appendChild(toast);
    }
    toast.querySelector(".toast__title").textContent = title;
    toast.querySelector(".toast__text").textContent = text;
    // Re-trigger the transition if it was already open.
    toast.classList.remove("is-visible");
    void toast.offsetWidth;
    toast.classList.add("is-visible");
    clearTimeout(timer);
    timer = setTimeout(hideToast, 6000);
  }

  form.addEventListener("submit", function (e) {
    e.preventDefault();

    var value = input.value.trim();
    form.classList.remove("is-success", "is-error");

    if (!emailPattern.test(value)) {
      form.classList.add("is-error");
      input.setAttribute("aria-invalid", "true");
      if (msg) {
        msg.textContent = value ? "That email looks off. Mind checking it?" : "Type your email first — we can’t guess it.";
      }
      input.focus();
      return;
    }

    input.removeAttribute("aria-invalid");
    form.classList.add("is-success");
    if (msg) {
      msg.textContent = "";
    }
    showToast("You’re in!", "Check " + value + " for your $10 off. (Demo — nothing was sent.)");
    form.reset();
  });
});
